module.exports = __webpack_public_path__ + "static/img/3.759ba79.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/objectRecognition/unity/3.png
// module id = eBBd
// module chunks = 1